import { Row, Col } from "react-bootstrap";
import Loading from "../../../components/core/blocks/Loading";
import PriceDetails from "../PriceDetails";
import AdDetails from "../AdDetails";
import { PricingProductUnavailable } from "../components/PricingProductUnavailable";

const PriceHistorySection = ({
  pricingProduct,
  pricingProductError,
  isPricingProductDataLoading,
  marketPlace,
  isLoading,
  advertising = false,
}) => {
  const channel = "AMZ";

  if (isLoading || isPricingProductDataLoading) {
    return <Loading height={"300px"} fullPage={false} />;
  }

  if (pricingProductError || !pricingProduct) {
    return <PricingProductUnavailable error={pricingProductError} />;
  }

  return (
    <Row>
      <Col xs={12}>
        {!advertising && <PriceDetails optData={pricingProduct} channel={channel} marketPlace={marketPlace} />}
        {advertising && <AdDetails optData={pricingProduct} channel={channel} marketPlace={marketPlace} />}
      </Col>
    </Row>
  );
};

export default PriceHistorySection;
